/**
 * Preserves selection start and end on model change.
 * Prevents cursor jumping to end of input.
 */
angular.module('tgaAdmin').directive('preserveCursor', () => ({
  require: 'ngModel',
  restrict: 'A',
  link(scope, element, attrs, modelCtrl) {
    modelCtrl.$formatters.push((value) => {
      if (value !== modelCtrl.$viewValue) {
        const cursorStart = element.prop('selectionStart');
        const cursorEnd = element.prop('selectionEnd');

        // Cache the $pristine value and temporarily set it to false
        // to prevent $setViewValue() from calling $setDirty().
        const pristineValue = modelCtrl.$pristine;
        try {
          modelCtrl.$pristine = false;
          modelCtrl.$setViewValue(value);
          modelCtrl.$render();
        } finally {
          // Restore $pristine value no matter what.
          modelCtrl.$pristine = pristineValue;
        }

        element.prop('selectionStart', cursorStart);
        element.prop('selectionEnd', cursorEnd);
      }
      return value;
    });
  },
}));
